<script setup lang="ts">
import { useMutation } from '@tanstack/vue-query';
import useInvitation from './useInvitation';
import { captureException } from '@sentry/vue';
import { ref } from 'vue';
import USDValue from '@/components/molecules/USDValue.vue';

defineProps<{
  amount: number | null;
}>();

const emit = defineEmits(['cancel', 'success']);

const { create } = useInvitation();

const txError = ref<string | null>(null);

const { mutate: createInvitation, isPending } = useMutation({
  mutationFn: create,
  onSuccess: (invite) => {
    emit('success', invite);
  },
  onError: (error) => {
    console.error(error);
    txError.value = 'An error occurred, please try again';
    captureException(error);
  },
});
</script>

<template>
  <v-card class="p-8 flex flex-column gap-4 items-center bg-brand-background">
    <p class="text-2xl font-bold">Invite summary</p>

    <div class="flex flex-col items-center gap-1">
      <p class="text-4xl font-bold">{{ amount }} SOL</p>
      <USDValue :value="amount" class="opacity-50" />
    </div>
    <div class="p-4 rounded-jup flex flex-column gap-2 text-sm bg-[#051D2D]">
      <p>
        Jupiter will generate a unique link for your friend to download the app
        and claim their gift!
      </p>
      <p>
        Your funds will remain securely on-chain until claimed or returned to
        you after 7 days.
      </p>
    </div>
    <div class="flex flex-col gap-2 w-full">
      <v-btn
        :disabled="isPending || !amount"
        @click="createInvitation(amount!)"
        class="w-full"
        size="large"
        variant="elevated"
        color="#1EFDE7"
        :loading="isPending"
        >Confirm</v-btn
      >
      <v-btn @click="emit('cancel')" class="w-full" size="large">Cancel</v-btn>
    </div>
    <p v-if="txError" class="text-red-300">{{ txError }}</p>
  </v-card>
</template>
